import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token, { expires: 1 })
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function authPermission(permission) {
  const all_permission = "*:*:*";
  const permissions = JSON.parse(localStorage.getItem('permissions') || '[]');
  if (permission && permission.length > 0) {
    return permissions.some(v => {
      return all_permission === v || v === permission
    })
  } else {
    return false
  }
}

export function authFirstMenu(permission) {
  const firstMenus = JSON.parse(localStorage.getItem('firstMenus') || '[]');
  if (permission && permission.length > 0) {
    return firstMenus.some(v => {
      return v === permission
    })
  } else {
    return false
  }
}

export function authSecondMenu(permission) {
  const secondMenus = JSON.parse(localStorage.getItem('secondMenus') || '[]');
  if (permission && permission.length > 0) {
    return secondMenus.some(v => {
      return v === permission
    })
  } else {
    return false
  }
}



export default {
  // 验证用户是否具备某权限
  hasPermi(permission) {
    return authPermission(permission);
  },
  hasFirstMenu(permission) {
    return authFirstMenu(permission);
  },
  hasSecondMenu(permission) {
    return authSecondMenu(permission);
  },
}

